/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.95"
        height="95.58"
        viewBox="0 0 79.95 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="none"
          stroke="#ffb81c"
          d="M60.33 24.59v-9.73a13.62 13.62 0 0 0-27.23 0v9.73"
          className="icon-stroke icon-accent"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="none"
          stroke="#0e497b"
          d="m69.7 94.33 9-3.6V29.49l-9-3.6H1.25v68.44H69.7z"
          className="icon-stroke icon-base"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="none"
          stroke="#ffb81c"
          d="M46.86 36.31V14.86a13.62 13.62 0 0 0-27.23 0v21.45"
          className="icon-stroke icon-accent"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="#0e497b"
          d="M69.7 25.02a1.25 1.25 0 0 1 1.24 1.13v67.89a1.252 1.252 0 0 1-2.5.13v-67.9a1.25 1.25 0 0 1 1.26-1.25Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperShoppingBagEmptyIcon';

export default Icon;
